import * as d3 from 'd3'

export default {
  methods: {

    draw_Elements() {

      this.Trend = this.svg
      .append('g')
      .attr('transform', `translate(${this.Chart.x +.5}, ${this.Chart.y + .5})`)
      .style('font-family', 'roboto')

      this.draw_ChartCanvas()
      this.draw_Title()
      this.draw_Grids()
    },

    
    draw_ChartCanvas() {
      this.Trend
      .append('line')
      .attr('x1', 0).attr('x2', 0).attr('y1', 0).attr('y2', this.Chart.height)
      .attr('stroke', this.Chart.sColor ).attr('stroke-width', this.Chart.sWidth)
      .attr('opacity', this.Chart.opacity)

      this.Trend
      .append('line')
      .attr('x1', 0).attr('x2', this.Chart.width).attr('y1', this.Chart.height).attr('y2', this.Chart.height)
      .attr('stroke', this.Chart.sColor ).attr('stroke-width', this.Chart.sWidth)
      .attr('opacity', this.Chart.opacity)

      this.Trend
      .append('line')
      .attr('x1', this.Chart.width).attr('x2', this.Chart.width).attr('y1', 0).attr('y2', this.Chart.height)
      .attr('stroke', this.Chart.sColor ).attr('stroke-width', this.Chart.sWidth)
      .attr('opacity', this.Chart.opacity)
    },


    draw_Title() {
      let x_ = 0
      let align_ = 'start'
      if (this.Title.align == 'center') {
        x_ = this.Chart.width/2
        align_ = 'middle'
      } else if (this.Title.align == 'right') {
        x_ = this.Chart.width
        align_ = 'end'
      }

      if (this.Title.main.visible == 'Y') {
        this.Trend
        .append('text')
        .attr('x', x_)
        .attr('y', -this.Title.main.margin + this.Title.main.tSize*0.26)
        .style('font-size', this.Title.main.tSize).style('fill', this.Title.main.tColor)
        .attr('text-anchor', align_)
        .text(this.Title.main.Text)
      }
    },


    draw_Grids() {
      // Draw Grid each Week
      let height_ = this.Chart.height / 5
      for(let i=0; i<6; i++) {
        this.Trend
        .append('line')
        .attr('x1', 0).attr('x2', this.Chart.width)
        .attr('y1', height_ * i).attr('y2', height_ * i)
        .attr('stroke', '#E0E0DF').attr('stroke-width', 0.5)
        .attr('opacity', 0.5)
      }

      // Draw Grid each Stack
      for(let i=0; i<6; i++) {
        this.Trend
        .append('line')
        .attr('x1', 0).attr('x2', -2)
        .attr('y1', height_ * i).attr('y2', height_ * i)
        .attr('stroke', '#757575').attr('stroke-width', 0.5)

        this.Trend
        .append('text')
        .attr('x', -this.Primary.value.margin)
        .attr('y', height_ * i + this.Primary.value.tSize*0.26)
        .style('font-size', this.Primary.value.tSize).style('fill', this.Primary.value.tColor)
        .attr('text-anchor', 'end')
        .text(`${(this.Primary.max-(i*(this.Primary.max/5))).toFixed(1)}%`)
      }

      // Draw Axis's Title
      this.Trend
      .append('text')
      .attr('transform', `translate(${-this.Primary.title.margin + this.Primary.title.tSize*0.26}, ${this.Chart.height/2}) rotate(-90)`)
      .style('font-size', this.Primary.title.tSize).style('fill', this.Primary.title.tColor)
      .attr('text-anchor', 'middle')
      .text(this.Primary.title.name)
      
    },

    

  }
}
